// getNumberInRange(-2, 0, 5) -> 0;
// getNumberInRange(7, 0, 5) -> 5;
// getNumberInRange(2, 0, 5) -> 2;
export const getNumberInRange = (number: number, min: number, max: number): number => {
  const upperBound = Math.min(number, max);

  return Math.max(upperBound, min);
};

export type TryParseValidIntegerOptions = { min?: number; max?: number };
export type TryParseValidIntegerResult = {
  success: boolean;
  parseResult: number | null;
  isLessThanMin: boolean;
  isGreaterThanMax: boolean;
};

export const tryParseValidInteger = (
  inputString: string,
  options?: TryParseValidIntegerOptions,
): TryParseValidIntegerResult => {
  const min = options?.min ?? Number.MIN_SAFE_INTEGER;
  const max = options?.max ?? Number.MAX_SAFE_INTEGER;
  const parsedValue = Number(inputString);

  const isInteger = Number.isInteger(parsedValue);
  const isLessThanMin = isInteger && parsedValue < min;
  const isGreaterThanMax = isInteger && parsedValue > max;

  const success = isInteger && !isLessThanMin && !isGreaterThanMax;

  return {
    success,
    parseResult: success ? parsedValue : null,
    isLessThanMin,
    isGreaterThanMax,
  };
};
